import React from 'react';
import { Modal } from 'react-bootstrap';

interface ModalComponentProps {
    children?: React.ReactNode;
    isShow: boolean;
    onClose: () => void;
    title?: string | any;
    className?: string;
    footerButtons?: React.ReactNode;
    type?: "Danger" | "Warning" | "Success" | "Info" | "Primary",
    size?: "sm" | "lg" | "xl";
    scrollable?: boolean,
    canClose?: boolean
}

const ModalComponent: React.FC<ModalComponentProps> = ({ size, isShow, onClose, title, footerButtons, scrollable, children, className, type, canClose = true }) => {
    return (
        <Modal
            size={size}
            show={isShow}
            onHide={onClose}
            backdrop={canClose ? true : "static"}
            keyboard={canClose ? true : false}
            centered
            className={`${type?.toLowerCase() ?? ""} ${className ?? ""}`}
            scrollable={scrollable}>

            {title && (
                <Modal.Header closeButton={canClose} className={(type ? ('bg-' + type.toLowerCase()) : "")}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            )}

            <Modal.Body className={(type ? ('bg-' + type.toLowerCase()) : "")}>{children}</Modal.Body>

            {footerButtons && <Modal.Footer>{footerButtons}</Modal.Footer>}
        </Modal>
    );
};

export default ModalComponent;
